<template>
  <div id="pg-footer">
    <div class="ui-c">
      <div class="ly-c">
        <div class="fn-flex ly-m">
          <div class="itemleft">
            <div class="elogo"><img src="@/assets/images/logo.png" /></div>
            <div class="said">{{ footerData.tellthem || '' }}</div>
            <div class="share">
              <ul>
                <li><a href="javascript:;" @click="shareTo('tiktok', currentLang.value)"><i class="iconfont icon-tiktok"></i></a></li>
                <li><a href="javascript:;" @click="shareTo('x', currentLang.value)"><i class="iconfont icon-x"></i></a></li>
                <li><a href="javascript:;" @click="shareTo('facebook', currentLang.value)"><i class="iconfont icon-facebook"></i></a></li>
                <li><a href="javascript:;" @click="shareTo('ins', currentLang.value)"><i class="iconfont icon-ins"></i></a></li>
                <li><a href="javascript:;" @click="shareTo('linkedin', currentLang.value)"><i class="iconfont icon-lingying"></i></a></li>
              </ul>
            </div>
          </div>
          <div class="itemcenter">
            <div class="contact">
              <div class="items">
                <div class="p1"><i class="iconfont icon-dianhua"></i>{{ $t('common.kefuHotline') }}</div>
                <div class="p2"><a :href="`tel:${footerData.phone}`">{{ footerData.phone || '' }}</a></div>
              </div>
              <div class="items">
                <div class="p1"><i class="iconfont icon-youxiang1"></i>{{ $t('common.kefuEmail') }}</div>
                <div class="p2"><a :href="`mailto:${footerData.email}`">{{ footerData.email || '' }}</a></div>
              </div>
              <div class="items">
                <div class="p1"><i class="iconfont icon-dizhi"></i>{{ $t('common.companyAddress') }}</div>
                <div class="p2">{{ footerData.address || '' }}</div>
              </div>
            </div>
          </div>
          <div class="itemright">
            <div class="qrcode">
              <div class="qr_1">
                <p><img src="@/assets/images/code.jpg" /></p>
                <p>{{ $t('common.kefuQrcode') }}</p>
              </div>
              <div class="qr_1">
                <p><img src="@/assets/images/website.png" /></p>
                <p>{{ $t('common.websiteQrcode') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-f">
      <div class="ly-c">
        <div class="ly-m">
          <div class="itembottom">
            <!-- 🔥 正确：绑定接口的 copyright（接口已按lang返回对应语言） -->
            <div class="copyright">{{ footerData.description || '' }}</div>
            <div class="privacy">
              <!-- 备案信息：号码在 setup() 里的 icp 对象改；留空则自动不显示 -->
              <a
                v-if="icp.no"
                :href="icp.url"
                target="_blank"
                rel="noopener noreferrer"
                class="icp"
              >{{ icp.no }}</a>
              <a
                v-if="icp.policeNo"
                :href="icp.policeUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="icp"
              >{{ icp.policeNo }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="pg-navs">
    <div class="nav">
      <ul>
        <li :class="{ curr: $route.path === '/' || $route.path === '/index' }">
          <router-link to="/index"><div class="icons"><div class="iconfont icon-shouye1"></div></div><div class="font">{{ $t('nav.home') }}</div></router-link>
        </li>
        <li :class="{ curr: $route.path === '/about' }">
          <router-link to="/about"><div class="icons"><div class="iconfont icon-women"></div></div><div class="font">{{ $t('nav.about') }}</div></router-link>
        </li>
        <li :class="{ curr: $route.path === '/service' }">
          <router-link to="/service"><div class="icons"><div class="iconfont icon-hangye"></div></div><div class="font">{{ $t('nav.service') }}</div></router-link>
        </li>
        <li :class="{ curr: $route.path.startsWith('/news') }">
          <router-link to="/news"><div class="icons"><div class="iconfont icon-xinwen"></div></div><div class="font">{{ $t('nav.news') }}</div></router-link>
        </li>
        <li :class="{ curr: $route.path === '/contact' }">
          <router-link to="/contact"><div class="icons"><div class="iconfont icon-lianxirenxinxi"></div></div><div class="font">{{ $t('nav.contact') }}</div></router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import cmapi from '@/config/api.js'
  import { ref, onMounted, onErrorCaptured, watch } from 'vue'
  import { useLang } from '@/composables/useLang'
  import { useShare } from '@/composables/useShare'

  export default {
    name: 'CmFooter',
    props: {
      msg: String
    },
    setup() {
      const { lang, setLang } = useLang()
      const currentLang = lang
      const { shareTo } = useShare()

      /**
       * 底部备案信息 —— 以后只要改这里（留空就不显示那一项）。
       * 工信部备案查询：https://beian.miit.gov.cn/
       * 公安备案查询：  https://beian.mps.gov.cn/
       */
      const icp = {
        no: '鲁ICP备2025142131号-4',
        url: 'https://beian.miit.gov.cn/',
        policeNo: '', // 公安备案号（没有就留空，自动隐藏）
        policeUrl: 'https://beian.mps.gov.cn/'
      }

      // 🔥 修正：只保留接口返回的字段（无 _en 后缀）
      const footerData = ref({
        sitename: '',
        phone: '',
        email: '',
        address: '',
        description: '',
        tellthem: '',
        copyright: ''
      })

      const loadFooterData = async () => {
        try {
          const apiUrl = cmapi?.baseUrl
            ? `${cmapi.baseUrl}/comm/footer.php`
            : '/api/comm/footer.php'

          const res = await axios.get(apiUrl, {
            params: { lang: currentLang.value },
            timeout: 3000,
            cache: false
          })

          if (res.data.code === 200) {
            // 🔥 修正：直接赋值接口返回的data（无 _en 字段）
            footerData.value = {
              sitename: res.data.data.sitename || '',
              phone: res.data.data.phone || '',
              email: res.data.data.email || '',
              address: res.data.data.address || '',
              description: res.data.data.description || '',
              tellthem: res.data.data.tellthem || '',
              copyright: res.data.data.copyright || ''
            }
          }
        } catch (error) {
          // 重置为空
          footerData.value = {
            sitename: '',
            phone: '',
            email: '',
            address: '',
            description: '',
            tellthem: '',
            copyright: ''
          }
          console.log('加载footer数据失败：', error)
        }
      }

      const handleSwitchLang = (langVal) => {
        setLang(langVal)
        loadFooterData() // 切换语言重新请求接口（接口会返回对应语言的字段）
      }

      watch(currentLang, (newLang) => {
        if (newLang) {
          loadFooterData()
        }
      })

      onErrorCaptured((err) => {
        console.log('footer组件错误：', err)
        return true
      })

      onMounted(() => {
        setTimeout(loadFooterData, 100)
      })

      return {
        currentLang,
        handleSwitchLang,
        footerData,
        shareTo,
        icp
      }
    }
  }
</script>

<style scoped lang="scss">
  #pg-footer {
    background-color: var(--main);
    .ui-c {
      display: inline-block;
      width: 100%;
      padding:3rem 0;
    }
    .ui-f {
      display: inline-block;
      width: 100%;
      border-top:1px solid rgba(255,255,255,0.1);
    }
    .itemleft {
      width: 280px;
      .elogo {
        height: 45px;
      }
      img {
        height: 100%;
      }
      .said {
        color: #fff;
        font-size: 1rem;
        line-height: 1.5rem;
        margin: 3rem 0;
      }
      .share {
        ul {
          display: flex;
        }
        li {
          margin-right: 10px;
          cursor: pointer;
          a {
            color: #fff;
            text-decoration: none;
          }
          i {
            font-size: 1.8rem;
            transition: color 0.3s ease;
          }
          &:hover i {
            color: var(--fontred);
          }
        }
      }
    }
    .itemcenter {
      .contact {
        display: block;
        .items {
          margin-bottom: 1.5rem;
        }
        div {
          color: #fff;
          font-size: 1rem;
          line-height: 1.5rem;
        }
        .p1 {
          display: inline-flex;
          width: 100%;
          align-items: center;
          justify-content: flex-start;
          font-size: 1.1rem;
        }
        .p2 {
          color:rgba(255,255,255,0.7);
          font-size: 1rem;
        }
        .iconfont {
          font-size: 1.4rem;
          margin-right: 0.2rem;
        }
        a {
          color:rgba(255,255,255,0.7);
          font-size: 1rem;
        }
      }
    }
    .itemright {
      .qrcode {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap:0.5rem;
        .qr_1 {
          text-align: center;
          p {
            color:rgba(255,255,255,0.5);
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
    .itembottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 6px 0;
      padding: 10px 0;
      color: #fff;
      .privacy {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-end;
        gap: 0 4px;
      }
      .privacy a {
        color: #fff;
        margin-left: 15px;
        text-decoration: none;
        &:hover {
          color: var(--fontred);
        }
      }
    }
  }
  #pg-navs {
    display: none;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    z-index:200;
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    li {
      width: 20%;
      text-align: center;
    }
    a {
      display: inline-block;
      width: 100%;
      padding: 0.6rem 0;
    }
    .icons {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 1.8rem;
    }
    .iconfont {
      color:var(--main);
      font-size: 1.5rem;
    }
    .font {
      color: #000;
      font-size: 0.65rem;
      line-height: 1.2rem;
      text-transform: uppercase;
    }
    li.curr {
      .iconfont {
        color:var(--fontred);
      }
      .font {
        color:var(--fontred);
      }
    }
  }

  @media (min-width: 0px) and (max-width: 479px) {
    #pg-footer {
      .itemcenter {
        .contact {
          .items {
            .p1 {
              font-size: 1rem;
            }
            .p2 {
              font-size: 0.9rem;
            }
          }
        }
      }
    }
    #pg-navs {
      display: block;
    }
    .itemleft {
      display: none;
    }
    .itemright {
      display: none;
    }
  }
  @media (min-width: 480px) and (max-width: 1279px) {
    #pg-footer {
      .itemcenter {
        .contact {
          .items {
            .p1 {
              font-size: 1rem;
            }
            .p2 {
              font-size: 0.9rem;
            }
          }
        }
      }
    }
    #pg-navs {
      display: block;
    }
    .itemleft {
      display: none;
    }
    .itemright {
      display: none;
    }
  }
  @media (min-width: 640px) and (max-width: 959px) {
    #pg-footer {
      .itemleft {
        display: block;
      }
      .itemcenter {
        padding-left:2rem;
      }
    }
  }
  @media (min-width: 960px) and (max-width: 1279px) {
    #pg-footer {
      .itemleft {
        display: block;
      }
      .itemcenter {
        display: block;
      }
      .itemright {
        display: block;
      }
      .itemcenter {
        padding-left:2rem;
      }
    }
    #pg-navs {
      display: none;
    }
  }
</style>